import styled from 'styles/styled';

export const PpBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  @media (min-width: 720px) {
    align-items: center;
  }
`;

export const PpSheet = styled.div`
  background: #0B0D11;
  border-top: 1px solid #1C1F25;
  border-radius: 16px 16px 0 0;
  padding: 14px;
  width: 100%;
  max-width: 560px;
  height: 80%;
  display: flex;
  flex-direction: column;

  @media (min-width: 720px) {
    border-radius: 16px;
    border: 1px solid #1C1F25;
    height: 70vh;
    max-height: 640px;
  }
`;

export const PpHandle = styled.div`
  flex-shrink: 0;
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #535D70;
  margin: 0 auto 12px;

  @media (min-width: 720px) {
    display: none;
  }
`;

export const PpCloseBtn = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 0;
  color: #EFEFEF;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  z-index: 31;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const PpSearch = styled.div`
  flex-shrink: 0;
  background: #292B2E;
  border-radius: 10px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;

  input {
    background: transparent;
    border: 0;
    color: #EFEFEF;
    font-size: 14px;
    outline: none;
    flex: 1;
    font-family: inherit;
    padding: 0;
  }

  input::placeholder {
    color: #7A7E8C;
  }

  .ic {
    color: #7A7E8C;
    font-size: 14px;
  }
`;

export const PpCats = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .c {
    flex-shrink: 0;
    background: #1B1F25;
    border: 1px solid #292B2E;
    border-radius: 999px;
    padding: 0 14px;
    height: 30px;
    line-height: 28px;
    font-size: 12px;
    color: #EFEFEF;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 500;
    font-family: inherit;
    transition: background 120ms ease, color 120ms ease, border-color 120ms ease;

    &:hover {
      background: #292B2E;
    }

    &.on {
      background: #15191E;
      border-color: #52D381;
      color: #52D381;
      font-weight: 700;
    }
  }
`;

export const PpList = styled.div`
  overflow-y: auto;
  flex: 1;
  margin: -2px;
  padding: 2px;
`;

export const PpRow = styled.div<{ $active?: boolean }>`
  display: grid;
  grid-template-columns: 28px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  background: ${(p) => (p.$active ? 'rgba(82, 211, 129, 0.06)' : 'transparent')};
  border: 1px solid ${(p) => (p.$active ? 'rgba(82, 211, 129, 0.18)' : 'transparent')};
  transition: background 120ms ease, border-color 120ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.03);
  }

  .ic {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: #fff;
    overflow: hidden;
    background: #292B2E;
  }

  .ic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .nm {
    font-size: 13px;
    font-weight: 500;
    color: #EFEFEF;

    small {
      display: block;
      color: #7A7E8C;
      font-size: 11px;
      margin-top: 2px;
    }
  }

  .pr {
    text-align: right;
    font-size: 13px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: #EFEFEF;

    small {
      display: block;
      font-size: 11px;
      font-weight: 500;
      margin-top: 2px;

      &.up_state {
        color: #52D381;
      }

      &.down_state {
        color: #FF6782;
      }
    }
  }
`;

export const PpEmpty = styled.div`
  padding: 24px 8px;
  text-align: center;
  color: #7A7E8C;
  font-size: 12px;
`;

export const PairTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #292B2E;
  border: 0;
  border-radius: 10px;
  padding: 6px 10px;
  color: #EFEFEF;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  font-family: inherit;
  transition: background 120ms ease;

  &:hover {
    background: #1B1F25;
  }

  .ico {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #15191E;
  }

  .ico img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .chev {
    color: #7A7E8C;
    font-size: 10px;
    margin-left: 2px;
  }
`;
